export default __webpack_public_path__ + "static/media/Avatar.142d8ea0.png";